<template>
  <div class="drawer">
    <!-- 遮罩层 -->
    <div class="mask-show" v-if="drawerShow" @click="close()" ></div>
    <!-- 抽屉层 -->
    <div class="setbox" :class="{show: drawerShow}">
      <button class="off" @click="close()">×</button>
      <div class="header">
        <slot />        
      </div>      
    </div>
  </div>
</template>
<script>
  // 引入js文件
  import Drawer from "./drawer.ts";
  // 使用js对象
  export default {
    ...Drawer,
  };
</script>
<style lang="scss" scoped>
    @import "./drawer.scss";
</style>
